import { Text } from 'react-native'
import styles from '../../../Style'
import { useFormContext } from '../FormProvider'

const AllowArtistsSignUp = () => {
  const { formData, setFormData, errors } = useFormContext()
  const isOpenMic = formData.ArtRunner === 'Open Mic'
  const isWorkshop = formData.ArtRunner === 'Workshop'

  const handleCheckboxChange = key => {
    setFormData(prevForm => ({
      ...prevForm,
      [key]: !prevForm[key]
    }))
  }

  return (
    <div style={{ marginBottom: 20 }}>
      <div
        className={
          !isWorkshop
            ? 'display-block checkbox-container'
            : 'display-none checkbox-container'
        }
      >
        <label
          className='checkbox-container'
          style={{ display: 'flex', alignItems: 'center', gap: 5 }}
        >
          <input
            type='checkbox'
            checked={formData.PersonallyApprove}
            onChange={() => {
              setFormData(prevForm => ({
                ...prevForm,
                PersonallyApprove: isOpenMic || !prevForm.PersonallyApprove,
                ...(!prevForm.PersonallyApprove && {
                  NumberSpots: null,
                  Requirements: null,
                  CustomDate: null,
                  CustomTime: null,
                  AlwaysVisible: null
                })
              }))
            }}
          />
          {!isOpenMic && <span className='checkmark'></span>}
          <Text className='approve_a' style={styles.labelPhotos}>
            {isOpenMic ? (
              <div>
                <span style={{ color: 'red', fontWeight: 700 }}>
                  Sign-Up For Artist
                </span>{' '}
                Is Enabled Select More Options If Necessary
              </div>
            ) : (
              'Allow Artists To Sign-Up?'
            )}
          </Text>
        </label>

        {formData.PersonallyApprove && (
          <>
            <div
              style={{
                marginTop: 10,
                display: 'flex',
                alignItems: 'center',
                gap: 155
              }}
            >
              <Text style={styles.label}>
                <span style={{ width: '130px', display: 'block' }}>
                  {isOpenMic ? 'Total Spots' : 'Bonus Bucket Spots'}
                </span>
              </Text>
              <div
                className={`Category_name ${
                  errors.NumberSpots ? 'invalid' : 'valid'
                }`}
                style={{ width: '30%' }}
              >
                <input
                  type='number'
                  placeholder='#'
                  value={formData.NumberSpots || ''}
                  onChange={e =>
                    setFormData(prevForm => ({
                      ...prevForm,
                      NumberSpots: e.target.value
                    }))
                  }
                />
              </div>
            </div>
            <p style={{ color: 'red', fontWeight: 700, fontSize: 14 }}>
              {errors.Guests}
            </p>

            {['Guests', 'SupportVenue', 'MultipleSignup'].map((key, index) => (
              <label
                key={index}
                className='checkbox-container'
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 15,
                  marginTop: 8
                }}
              >
                <input
                  type='checkbox'
                  checked={formData[key]}
                  onChange={() => handleCheckboxChange(key)}
                />
                <span className='checkmark'></span>
                <div className='Purchase' style={{ display: 'flex', gap: 50 }}>
                  <Text style={styles.labelPhoto}>
                    {key === 'SupportVenue'
                      ? 'Support Venue'
                      : key === 'MultipleSignup'
                      ? 'Stage Time'
                      : key}
                  </Text>
                  <Text style={styles.label} className="Bringing" >
                    {key === 'Guests' &&
                      'Ask Artists if They Are Bringing Guests'}
                    {key === 'SupportVenue' &&
                      'Ask Artists If They Plan To Make A Purchase At The Venue'}
                    {key === 'MultipleSignup' &&
                      'Ask Artists Preferred Stage Time'}
                  </Text>
                </div>
              </label>
            ))}
          </>
        )}
      </div>
      {formData.PersonallyApprove && (
        <div
          className={`Category_name ${
            errors.Requirements ? 'invalid' : 'valid EventUpdateZindex'
          }`}
          style={{ width: '100%',padding:5,boxSizing:"border-box", marginTop: 20, height: 154 }}
        >
          <textarea
            value={formData.Requirements || ''}
            onChange={e =>
              setFormData(prevForm => ({
                ...prevForm,
                Requirements: e.target.value
              }))
            }
            placeholder='What Should Artists Know Before Signing Up?'
            style={{
              maxWidth: '100%',
              minWidth: '100%',
              maxHeight: '100%',
              minHeight: '100%',
              backgroundColor: 'transparent'
            }}
          ></textarea>
        </div>
      )}
    </div>
  )
}

export default AllowArtistsSignUp
